.vendor-lead-billing-info-step-layout__next-button {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;

  width: 240px;
}

@media screen and (width <=640px) {
  .vendor-lead-billing-info-step-layout__next-button {
    width: unset;
    padding: 24px 0;

    font-size: 24px;
  }
}